var map = {
	"./0319.mp4": 440,
	"./A_professional_football_stadium_at_night_illumina.png": 702,
	"./DALL·E 2025-03-05 21.50.24 - A professional football stadium at night, illuminated with bright lights. The field is empty, showcasing the green grass and stadium seating in the ba.webp": 777,
	"./KAMİL_SİTE_2.mp4": 606,
	"./arka_plan.jpg": 137,
	"./bacakarasi.gif": 589,
	"./kaleci.jpg": 707,
	"./news-2-3-368x287.jpg": 685,
	"./oyuncu_bul.jpg": 683,
	"./rakip.jpg": 57,
	"./saha2.png": 33,
	"./stadyum.jpg": 113,
	"./visa-mastercard.png": 344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;